import React, { Component } from "react";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import axios from "axios";
import * as appConst from "../../Common/constants";
import { Dropdown } from "primereact/dropdown";

class BankList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Banks: [],
      LedgerDetails: [],
      spinnerClass: "collapse",
      dataClass: "",
      dummy: { _id: "NA" },
      bank: "",
      balance: 0.0
    };
  }

  componentDidMount() {
    let _bankList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/Bank"
      )
      .then(response => {
        let bankData = response.data;

        bankData.forEach(function(item) {
          if (item.cash == false) {
            var obj = { label: item.name, value: item.bno };
            _bankList.push(obj);
          }
        });
        this.setState({ Banks: _bankList });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  };

  render() {
    return (
      <>
        <h5 align="center">Bank Ledger</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="row p-1">
            <div className="col col-md-2">Select Bank</div>
            <div className="col col-md-4">
              <Dropdown
                value={this.state.bank}
                options={this.state.Banks}
                placeholder="Select Bank"
                onChange={this.onBankChange}
                //optionLabel="name"
                style={{ width: "300px" }}
              />
            </div>
            <div className="col col-md-4 text-danger font-weight-bold">
              Balance : {this.state.balance}
            </div>
          </div>

          <div className="ag-theme-blue" style={this.getHeight()}>
            <div>
              <button
                onClick={this.onAddClick}
                className="btn btn-primary btn-sm mb-2 mr-2"
              >
                Add Ledger
              </button>
              <button
                onClick={this.onEditClick}
                className="btn btn-primary btn-sm mb-2"
              >
                Edit Ledger
              </button>
            </div>
            <AgGridReact
              rowData={this.state.LedgerDetails}
              pagination={true}
              enableSorting={true}
              enableFilter={true}
              onGridReady={this.onGridReady}
              paginationAutoPageSize={true}
            >
              <AgGridColumn field="_id" hide="true" />
              <AgGridColumn
                width={50}
                checkboxSelection
                filter={false}
                resizable
              />
              <AgGridColumn
                field="txnDate"
                headerName="Txn Date"
                width={150}
                sortable
                resizable
                filter
                valueFormatter={this.dateFormatter}
              />
              <AgGridColumn
                field="txnType"
                headerName="Txn Type"
                width={200}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="amount"
                headerName="Amount"
                width={150}
                sortable
                resizable
                filter
                valueFormatter={this.currencyFormatter}
              />
            </AgGridReact>
          </div>
          <Growl ref={el => (this.growl = el)} />
        </div>
      </>
    );
  }

  dateFormatter(params) {
    var arr = params.value.split("-");
    return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
  }

  currencyFormatter(params) {
    var parts = (params.value < 0 ? params.value * -1 : params.value)
      .toString()
      .split(".");
    return (
      parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      (parts[1] ? "." + parts[1] : ".00")
    );
  }

  onBankChange = e => {
    this.setState({ bank: e.target.value, balance: 0 });

    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          "/bankLedger/" +
          e.target.value
      )
      .then(response => {
        this.setState({ LedgerDetails: response.data });
      })
      .catch(function(error) {
        console.log(error);
      });

    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          "/bankLedger/getBalance/" +
          e.target.value
      )
      .then(response => {
        var parts = response.data[0].balance.toString().split(".");
        //var parts = (amt < 0 ? amt * -1 : amt).toString().split(".");
        var bal =
          parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          (parts[1] ? "." + parts[1] : ".00");
        this.setState({ balance: bal });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  onAddClick = e => {
    if (this.state.bank === "") {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "Select Bank !!"
      });
    } else this.props.onClick("", this.state.dummy, this.state.bank);
  };

  getHeight() {
    var hgt = window.innerHeight - 175;
    return { height: hgt + "px" };
  }

  onEditClick = e => {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length > 0)
      this.props.onClick("AddEdit", selectedNodes[0].data, this.state.bank);
    else {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "Select Bank !!"
      });
    }
  };
}

export default BankList;
